import { forwardRef, useState } from 'react';

import { cn } from '@/lib/utils';

import EyeballIcon from '../icons/eyeball';
import EyeballSlashIcon from '../icons/eyeball-slash';
import { Input } from './input';

export interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(({ className, error, ...props }, ref) => {
  const [hidden, setHidden] = useState(true);

  return (
    <div className={cn('relative w-full', className)}>
      <Input ref={ref} error={error} {...props} type={hidden ? 'password' : 'text'} />

      <button
        type="button"
        aria-label={hidden ? 'Show password' : 'Hide password'}
        className="absolute top-1/2 right-2 z-10 -translate-y-1/2 transform"
        onClick={() => setHidden((prev) => !prev)}>
        {hidden ? <EyeballSlashIcon /> : <EyeballIcon />}
      </button>
    </div>
  );
});
PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
